<template>
  <div class="list__body">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BaseListBody',
};
</script>
